<template>
  <el-popover placement="bottom" width="400" trigger="click" @show='getBranchInfo'>
    <div class='branch-info'>
      <div class="branch-title">{{ branchInfo.branchTeam }}</div>
      <div class='content-container'>
        <div v-for='(item, index) in contentList' :key='index' class='content-item'>
          <div class="label">{{ item.label }}</div>
          <div class="value">{{ branchInfo[item.value] }}</div>
        </div>
      </div>
    </div>
    <i class='el-icon-question popover-icon' slot="reference"></i>
  </el-popover>
</template>
<script>
export default {
  name: 'branchInfo',
  data () {
    return {
      branchInfo: {},
      contentList: [
        {label: '组织机构代码', value: 'branchTeamId'},
        {label: '所属基本法', value: 'basicVersionName'},
        {label: '建立时间', value: 'foundDate'}
      ]
    }
  },
  props: {
    branchId: ''
  },
  methods: {
    getBranchInfo (newId) {
      // this.$store.dispatch('branchBranchInfo', {branchId: newId || this.branchId}).then((res) => {
      //   this.branchInfo = res
      // })
      let params = `${newId || this.branchId}`
      return this.$store.dispatch('sysBranchOrgGetBranchTeamInfo', params).then((res) => {
        this.branchInfo = res.Data || {}
      })
    }
  }
}
</script>
<style lang='less' scoped>
.popover-icon {
  visibility: hidden;
  // &:hover {
  //   visibility: visible;
  // }
}
.branch-info {
  .branch-title {
    // height: 30px;
    line-height: 24px;
    text-align:center;
    border-bottom: 1px solid #eee;
  }
  .content-container {
    .content-item {
      height: 28px;
      line-height: 28px;
      .label {
        width: 100px;
        display: inline-block;
      }
      .value {
        display: inline-block;
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/branchInfo.vue